import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useVelavuModal } from "../../../../elements/velavu-modal";
import VelavuAlertModal from "../../../../elements/velavu-alert-modal/velavu-alert-modal";
import VelavuAlertModalTitle from "../../../../elements/velavu-alert-modal/velavu-alert-modal-title";
import VelavuAlertModalContent from "../../../../elements/velavu-alert-modal/velavu-alert-modal-content";
import VelavuAlertModalActions from "../../../../elements/velavu-alert-modal/velavu-alert-modal-actions";
import VelavuButton from "../../../../elements/velavu-button";

/**
 * Returns a function that pushes a modal that prompts the user if
 * they want to discard their changes or not.
 *
 * Returns false if the user does not want to discard changes,
 * true if they do, and undefined if they close the modal.
 */
export default function useDiscardModal(): () => Promise<boolean | undefined> {
	const { pushModal } = useVelavuModal();
	const { t } = useTranslation();

	return useCallback(() => {
		return pushModal<boolean>((resolve) => (
			<VelavuAlertModal>
				<VelavuAlertModalTitle>
					{t("settings.discard_modal.title")}
				</VelavuAlertModalTitle>

				<VelavuAlertModalContent>
					{t("settings.discard_modal.content")}
				</VelavuAlertModalContent>

				<VelavuAlertModalActions>
					<VelavuButton
						label={t("settings.discard_modal.cancel")}
						variant="outlined"
						fullWidth
						onClick={() => resolve(false)}
					/>

					<VelavuButton
						label={t("settings.discard_modal.discard")}
						fullWidth
						onClick={() => resolve(true)}
					/>
				</VelavuAlertModalActions>
			</VelavuAlertModal>
		));
	}, [pushModal, t]);
}
